// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__ogSER","Label":"BuildControl_Label__1ZBKG","Less":"BuildControl_Less__3BlxZ","More":"BuildControl_More__1nhQX"};